import React, { Component } from 'react';

class SelectedAnswers extends Component {
  getNameByCode(code, list) {
    let filteredList = list.filter(item => {
      return item.Code == code.value; // == porque capaz que viene como string del store
    });
    return filteredList && filteredList[0] && filteredList[0].Name;
  }

  render() {
    const {
      carYear, carModel, carBrand, goBackAuto,
      carModels, carBrands, carUsageArea,
    } = this.props;

    return (
      <div className="SelectedAnswers">
        <div className="SelectedAnswers-answerButton" onClick={() => {goBackAuto(3)}}>
          <span> {this.getNameByCode(carBrand, carBrands)} </span>
          <span className="SelectedAnswers-answerCross">x</span>
        </div>
        <div className="SelectedAnswers-answerButton" onClick={() => {goBackAuto(2)}}>
          <span> {carYear.label} </span>
          <span className="SelectedAnswers-answerCross">x</span>
        </div>
        <div className="SelectedAnswers-answerButton" onClick={() => {goBackAuto(1)}}>
          <span> {this.getNameByCode(carModel, carModels)} </span>
          <span className="SelectedAnswers-answerCross">x</span>
        </div>
        <div className="SelectedAnswers-answerButton" onClick={() => {goBackAuto(0)}}>
          <span> {carUsageArea.label} </span>
          <span className="SelectedAnswers-answerCross">x</span>
        </div>
      </div>
    );
  }
}

export default SelectedAnswers;
